// extracted by mini-css-extract-plugin
module.exports = {"errorScreen":"style_errorScreen__3IDUJ","errorContainer":"style_errorContainer__28Lfz","errorTitle":"style_errorTitle__3a97y"};